export const sendMessageToIframeParent = (
  event: string,
  params?: Record<string, unknown>
): void => {
  window.parent.postMessage({ event, params }, '*');
};
